import { getAssetAccessLevel } from '../shared/helpers/assetHelpers.js';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { StreamProvider } from '@vgtv/api-client';
import type { ProviderAccessMap } from '@vgtv/svp-access';

export const hasAssetAccess = <T extends StreamProvider>(
  asset: SvpAssetAdditional,
  accesses: ProviderAccessMap[T][]
): boolean => {
  const accessLevel = getAssetAccessLevel<T>(asset);

  return accessLevel ? hasAccess(accessLevel, accesses) : true;
};

export function hasAccess<T extends StreamProvider>(
  access: ProviderAccessMap[T],
  accesses: ProviderAccessMap[T][]
) {
  return accesses.includes(access);
}

export const isLoggedIn = <T extends StreamProvider>(
  accesses: ProviderAccessMap[T][]
): boolean => {
  return accesses.length > 0;
};
